import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { FigureLabel, SECTION_GAP, ThemedContainer, ThemedPanel, scaledPixels } from "./ThemedLayout";

const LEAD_QUOTE = {
  quote: "It's honestly insane how good the questions are that Jungle whips up from my lecture slides.",
  name: "Sam",
  role: "Student at U Miami",
};

// One pull quote, set large, in the display face. Nothing else competes with it.
export function ThemedTestimonials() {
  const theme = useLandingTheme();
  const isSticker = theme.id === "sticker-sheet";
  const QuoteWrapper = isSticker ? ThemedPanel : Box;
  return (
    <Box as="section" mt={SECTION_GAP}>
      <ThemedContainer>
        <QuoteWrapper maxW="940px" mx="auto" textAlign="center" {...(isSticker ? { px: "48px", py: "44px", transform: "rotate(-1deg)", bg: theme.color.surfaceAlt } : {})}>
          <FigureLabel figureNumber={3} label="Students" textAlign="center" />
          <Text
            fontFamily={theme.font.display}
            fontWeight={theme.heading.weight >= 700 ? 600 : theme.heading.weight}
            letterSpacing={theme.heading.letterSpacing}
            fontSize={{ base: scaledPixels(26, theme.heading.sizeScale), md: scaledPixels(34, theme.heading.sizeScale), lg: scaledPixels(38, theme.heading.sizeScale) }}
            lineHeight={1.15}
            color={theme.color.heading}
            sx={{ textWrap: "balance" }}
          >
            “{LEAD_QUOTE.quote}”
          </Text>
          <Text fontFamily={theme.font.body} mt="28px" fontSize="14px" fontWeight={600} letterSpacing="0.08em" textTransform="uppercase" color={theme.color.muted}>
            {LEAD_QUOTE.name}, {LEAD_QUOTE.role}
          </Text>
        </QuoteWrapper>
      </ThemedContainer>
    </Box>
  );
}
